export const ACTIVE = 'ACTIVE';
export const INCOMPLETE = 'REGISTRATION_INCOMPLETE';
export const DELETED = 'DELETED';
